var _g, _path, _g2, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEuroRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 77,
    viewBox: "0 0 101 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_107_2291)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 69.6377,
    cy: 31,
    r: 24,
    transform: "rotate(20 69.6377 31)",
    fill: "#26BFBF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.1936 40.0325C70.7249 40.2174 71.2551 40.3579 71.7842 40.4538C72.3133 40.5498 72.8315 40.5978 73.3388 40.5979L72.7394 43.6982C72.1209 43.6373 71.488 43.5383 70.8409 43.4013C70.1937 43.2642 69.5504 43.0844 68.9109 42.8618C67.7009 42.4406 66.6509 41.8766 65.7609 41.1697C64.8807 40.4662 64.1933 39.6368 63.6986 38.6815C63.2074 37.7164 62.9367 36.6405 62.8865 35.4539C62.8496 34.2608 63.0742 32.9658 63.5605 31.5689L65.3019 26.5664C65.8019 25.1301 66.4402 23.946 67.2168 23.0141C68.0067 22.0758 68.9021 21.3728 69.9032 20.9051C70.9141 20.4408 71.9945 20.2047 73.1443 20.1969C74.304 20.1925 75.5085 20.4077 76.7579 20.8426C77.3678 21.0549 77.9427 21.3047 78.4824 21.5918C79.0355 21.8726 79.5782 22.1829 80.1107 22.5226L78.6503 25.3397C78.2688 25.0415 77.8377 24.759 77.3569 24.4924C76.886 24.2292 76.3948 24.0086 75.8832 23.8305C75.1257 23.5668 74.4026 23.442 73.7139 23.4559C73.0351 23.4733 72.4037 23.6395 71.8197 23.9546C71.2391 24.2599 70.7107 24.7323 70.2345 25.3716C69.7681 26.0145 69.3619 26.8327 69.016 27.8263L67.2644 32.8582C66.9219 33.842 66.7423 34.7225 66.7254 35.4997C66.7218 36.2706 66.8544 36.9509 67.1234 37.5409C67.3957 38.121 67.791 38.6171 68.3094 39.0292C68.8376 39.4446 69.4657 39.7791 70.1936 40.0325ZM74.5249 29.0159L73.8211 31.0376L62.2816 27.0206L62.9853 24.999L74.5249 29.0159ZM73.1482 32.9707L72.4445 34.9923L60.9049 30.9754L61.6086 28.9537L73.1482 32.9707Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_107_2291)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30.6376,
    cy: 45,
    r: 24,
    transform: "rotate(-19.5113 30.6376 45)",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8133 51.6149C37.3408 51.4196 37.8392 51.1906 38.3084 50.928C38.7777 50.6654 39.208 50.3728 39.5995 50.0501L41.1096 52.8233C40.5936 53.1698 40.0424 53.4961 39.4559 53.8021C38.8694 54.1082 38.2587 54.3787 37.6238 54.6138C36.4222 55.0587 35.2533 55.2916 34.1169 55.3125C32.9903 55.3298 31.9323 55.1272 30.9428 54.705C29.9498 54.2729 29.0564 53.6151 28.2627 52.7315C27.4752 51.8346 26.8246 50.6926 26.311 49.3054L24.4718 44.3381C23.9437 42.9119 23.6828 41.5923 23.689 40.3792C23.7014 39.1528 23.945 38.0407 24.4198 37.0429C24.9043 36.0415 25.5876 35.172 26.4697 34.4344C27.3616 33.6932 28.4278 33.0929 29.6684 32.6336C30.2741 32.4093 30.8764 32.2362 31.4756 32.1144C32.0809 31.9791 32.697 31.8732 33.324 31.7965L33.9896 34.8991C33.5055 34.9117 32.9932 34.9681 32.4527 35.0683C31.9219 35.1648 31.4026 35.3071 30.8946 35.4952C30.1424 35.7737 29.5051 36.1374 28.9827 36.5864C28.47 37.0317 28.0886 37.5617 27.8386 38.1763C27.5849 38.7812 27.4777 39.4818 27.5171 40.2781C27.5662 41.0708 27.7735 41.9604 28.1388 42.947L29.9889 47.9436C30.3506 48.9205 30.7722 49.7141 31.2536 50.3245C31.7413 50.9215 32.2765 51.362 32.8593 51.646C33.4385 51.9203 34.0591 52.0515 34.7212 52.0396C35.3931 52.0241 36.0904 51.8826 36.8133 51.6149ZM33.1458 40.36L33.8891 42.3674L22.4306 46.6102L21.6873 44.6027L33.1458 40.36ZM34.5998 44.2869L35.3431 46.2944L23.8846 50.5371L23.1413 48.5297L34.5998 44.2869Z",
    fill: "#262626"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_107_2291",
    x: 33.8766,
    y: -2.76111,
    width: 71.5222,
    height: 71.5222,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_107_2291"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_107_2291",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_107_2291",
    x: -5,
    y: 11.3624,
    width: 71.2753,
    height: 71.2753,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_107_2291"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_107_2291",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuroRight);
export default __webpack_public_path__ + "static/media/euro_right.90c7e7f055238915d8943c6668869876.svg";
export { ForwardRef as ReactComponent };